<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>学生({{studentLength}})</h1>
        <span class="pull-right icon-right icon-setup text-hide" @click="popupVisibleStudentManage = true">更多</span>
      </div>
      <div class="liner"></div>
    </div>


    <!-- <mt-loadmore :top-method="loadTop" ref="loadmore" auto-fill="false"> -->
    <div class="main-page" >

    <mt-index-list>
      <li style="padding:10px 0">
        <div v-for="classInfo in classList" class="student-list bg-white">
          <div class="liner"></div>
          <router-link class="block  padding-15 clearfix group-name" :to="{path:'/class/edit/' + classInfo.classId}">
            <span class="block pull-left"><cite class=" font-16">{{classInfo.className}} </cite><cite class="gray">（{{classInfo.studentNum}}）</cite></span>
            <span class="pull-right gray font-12">
              <cite>
                <span v-for="teacher in classInfo.teacherList">
                  {{ teacher.teacherName }}&nbsp;
                </span>
              </cite>
            </span>
          </router-link>
        </div>
      </li>

      <!-- <ul class="list-group-item primary">
        <li class="list-group" v-for="student in studentList">
          <div class="liner"></div>
          <router-link class="group-link clearfix"  :to="{path:'/student/detail/' + student.studentId}">
            <span class="img-wrap small pull-left"><img :src="student.imageAddress ? (student.baseAcessPath + student.imageAddress) : img_default" width="40"/></span>
            <span class="group-txt">
              <span class="block overhide">
                <cite class="font-16 pull-left">{{student.studentName}}</cite><i v-bind:class="student.sex == '男' ? 'img-sex boy' : 'img-sex girl'" >{{student.sex}}</i>
                <cite class="gray pull-right  font-12" v-if="student.typeName">{{student.typeName}}</cite>
                <cite class="orange pull-right font-12" v-else>未添加托管服务</cite>
              </span>
            </span>
          </router-link>
        </li>
      </ul> -->

        <mt-index-section :index="firstCharList.firstChar" v-for="firstCharList in studentFirstCharList">
         <li class="list-group-item primary">
          <div class="list-group" v-for="student in firstCharList.students">
            <div class="liner"></div>
            <router-link class="group-link clearfix" :to="{path:'/student/detail/' + student.studentId}">
              <span class="img-wrap small pull-left">
                <img :src="student.imageAddress ? (student.baseAcessPath + student.imageAddress) : img_default" width="100%"/>
              </span>
              <span class="group-txt">
                <span class="block overhide">
                  <cite class="font-16 pull-left">{{student.studentName}}</cite>
                  <i v-bind:class="student.sex == '男' ? 'img-sex boy' : 'img-sex girl'" >{{student.sex}}</i>
                  <cite class="gray pull-right font-12" v-if="student.typeName">{{student.typeName}}</cite>
                  <cite class="orange pull-right font-12" v-else>未添加托管服务</cite>
                </span>
              </span>
            </router-link>
          </div>
          </li>
        </mt-index-section>
      </mt-index-list>

    </div>
    <!-- </mt-loadmore> -->

    <mt-popup
      v-model="popupVisibleStudentManage"
      position="bottom">
      <div class="shall text-center" style="width:100vw" @click="popupVisibleStudentManage = false">
      <div class="clearfix margin-15 font-12">
        <div class="col-xs-4"><router-link class="icon-add icon gray" :to="{path:'/invitation/parents'}">添加学生</router-link></div>
        <div class="col-xs-4"><router-link class="group-name icon gray" :to="{'path': '/class/add'}">建群</router-link></div>
        <div class="col-xs-4"><router-link class="icon-leave icon gray" :to="{'path': '/student/out'}">离托学生</router-link></div>
      </div>
      <ul class="list-group-item tinny" style="margin:0">
        <li class="list-group">
          <div class="liner"></div>
          <span class="group-txt">取消</span>
        </li>
      </ul>
    </div>
    </mt-popup>
  </div>
</template>

<script>
import { service } from '../../service'
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: mapGetters({
    classList: 'classList',
    studentLength: 'studentLength',
    studentFirstCharList: 'getStudentsByFirstChar'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      find_new_class_list_para: service.setPara('findNewClassList'),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      filterClassId: 0, // 全部:0 暂未分班:-1
      filterClassSfzt: '在托',
      popupVisibleStudentManage: false
    }
  },
  mounted: function () {
    this.find_new_class_list_para.curcheId = this.cookie_login_data.curcheId
    this.find_new_class_list_para.context = this

    this.get_new_student_list_para.curcheId = this.cookie_login_data.curcheId
    this.get_new_student_list_para.sfzt = this.filterClassSfzt
    this.get_new_student_list_para.context = this

    this.getClassList(true)
    this.getStuList(true)
  },
  methods: {
    ...mapMutations([
      'receiveStudents',
      'receiveClass',
      'clearStudents',
      'clearClass',
      'teacherClass'
    ]),
    loadTop (id) {
      this.clearClass()
      this.getClassList()
      this.clearStudents()
      this.getStuList()
      this.$refs.loadmore.onTopLoaded(id)
    },
    getClassList (isIndicator = false) {
      this.find_new_class_list_para.callback = () => {
        this.$store.dispatch('teacherClass', this.cookie_login_data.teacherId)
      }
      this.$store.dispatch('receiveClass', this.find_new_class_list_para)
    },
    getStuList (isIndicator = false) {
      this.$store.dispatch('receiveStudents', this.get_new_student_list_para)
    }
  }
}
</script>
<style scoped>
  .mint-popup-bottom{width:100vw;}
</style>


// WEBPACK FOOTER //
// StudentManage.vue?611696e8